"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TypographyTheme2 = _interopRequireDefault(require("./TypographyTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ChipTheme = function ChipTheme(colors, breakpoints) {
  var _TypographyTheme, _TypographyTheme$styl;

  return {
    styleOverrides: {
      root: _objectSpread(_objectSpread({}, ((_TypographyTheme = (0, _TypographyTheme2["default"])(colors, breakpoints)) === null || _TypographyTheme === void 0 ? void 0 : (_TypographyTheme$styl = _TypographyTheme.styleOverrides) === null || _TypographyTheme$styl === void 0 ? void 0 : _TypographyTheme$styl.body3) || {}), {}, {
        textAlign: 'center',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '24px',
        color: colors.white,
        backgroundColor: colors.userBlue,
        borderRadius: '4px'
      }),
      label: {
        margin: '0 12px',
        paddingLeft: 0,
        paddingRight: 0
      },
      deleteIcon: {
        color: colors.white,
        width: '12px',
        height: '12px',
        fontSize: '12px',
        '&:hover': {
          color: colors.white
        },
        margin: '2px 8px 0 -8px'
      },
      icon: {
        color: colors.white,
        width: '12px',
        height: '12px',
        cursor: 'pointer',
        marginTop: '2px',
        marginLeft: '8px',
        marginRight: '-8px'
      }
    }
  };
};

var _default = ChipTheme;
exports["default"] = _default;